import * as types from './actionTypes';  
import underWriterMpidApi from '../api/underWriterMpidApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2'

export function underWriterMpidList() {

  return {
    type: types.UNDERWRITER_MPID_LIST, 
  };
}

export function underWriterMpidListRes(data) {  
  return {
    type: types.UNDERWRITER_MPID_LIST_RES, 
    data
  };
}

export function getUnderwriterMpid() {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      underWriterMpidApi.underWriterMpidList().then(data => {
        dispatch(underWriterMpidListRes(data));
        dispatch(underWriterMpidListRes(null));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          })
        }
      }).catch(error => {
        return error
      });
    };
  }else{
    logout()
  }
}
